import React from "react";
import PageSection from "../../Components/PageSection";
import LonGTomMed from "../../images/longtom-med-medal.png";


export default class LongTom extends React.Component {
  render() {
  return (
    <div>
       <PageSection 
          headerText="Long Tom: Behind the Woods" 
          divider="New Release - Behind the World Trilogy" 
          showOppositeSide={false}
          banner="Final Book of the Behind the World Trilogy" 
          sectionContent={[
            "What lies at the back of the isolated hollow in the depths of eastern Tennessee? A glowing power of hope? Or a breach in the gates of Hell? Five sentinels stand ceaseless watch over the entrance to what locals call the Lonely, a rich, vibrant stand of forest that birds, animals, and even insects will not enter. And which kills any person who lingers too long within its shadows.",
            "“The entrance is threatened.” Thus reads the enigmatic warning received by Father Homer, and he hears the voice of God in those few words. Despite the protestations of his companion, Francisco Stampa, it is enough to send him to answer a desperate appeal for help from a terrified Lutheran minister in a small Tennessee town besieged by the forest, by fear, and by the growing enmity of a being calling himself Major Long Tom Gordon.",
            "Long Tom: Behind the Woods is the thundering conclusion of the Behind the World trilogy, and the conflicts that surged through Black Jack: Behind the Waves and Mortimer: Behind the Walls come to a stunning climax as dark questions are answered and ancient secrets revealed. ",
          ]}
          sideLink="https://www.amazon.com/gp/product/B0GL9MJ392"
          sidePicture={LonGTomMed}
      />
    </div>
  )}
}